import { itemsPerPage } from 'core/constants/pagination.constants';
import { DEFAULT_PAGE } from 'core/constants/platform.constants';
import { EApplications } from 'core/model/enums';
import { EBannerTarget } from 'core/model/enums/banners.enum';
import { IBannersState, IBannersVisualizationTabState } from './types';

export const SLICE_NAMESPACE = 'banners';

export const INITIAL_STATE_FOR_CREATION_TAB = {
  query: '',
  target: EBannerTarget.SEGMENT,
  loading: false,
  banners: [],
  pagination: {
    totalPages: 0,
    currentPage: 1,
    itemsPerPage,
    totalItems: 0,
  },
};

export const INITIAL_STATE_FOR_VISUALIZATION_TAB: IBannersVisualizationTabState = {
  loading: false,
  banners: [],
  branchIdList: [],
  priceListIdList: [],
  pagination: {
    totalPages: 0,
    currentPage: DEFAULT_PAGE,
    itemsPerPage,
    totalItems: 0,
  },
};

export const INITIAL_STATE: IBannersState = {
  creationTab: {
    [EApplications.GENERAL]: { ...INITIAL_STATE_FOR_CREATION_TAB },
    [EApplications.WEB]: { ...INITIAL_STATE_FOR_CREATION_TAB },
    [EApplications.APP]: { ...INITIAL_STATE_FOR_CREATION_TAB },
  },
  visualizationTab: {
    [EApplications.GENERAL]: { ...INITIAL_STATE_FOR_VISUALIZATION_TAB },
    [EApplications.WEB]: { ...INITIAL_STATE_FOR_VISUALIZATION_TAB },
    [EApplications.APP]: { ...INITIAL_STATE_FOR_VISUALIZATION_TAB },
  },
  form: {
    errors: {},
    success: false,
    loading: false,
    promotions: { options: [], isLoading: false },
  },
  modal: {
    loading: false,
    error: null,
    success: false,
  },
  publish: {
    loading: false,
    success: false,
    error: null,
  },
};
